import React from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useHistory } from 'react-router-dom';
import { useFeatureGate } from '@statsig/react-bindings';
import { useIsAdmin } from '@/hooks/useAuth';
import { useUserManagementEnabled } from '@/hooks/useUserManagementEnabled';

const SettingsTabs: React.FC = () => {
  const history = useHistory();
  const isAdmin = useIsAdmin();
  const userManagementEnabled = useUserManagementEnabled();

  const handleTabClick = (key: string) => {
    history.push(`/settings/${key}`);
  };

  const activeKey = history.location.pathname.split('/').pop();

  const { value: apiTokens } = useFeatureGate('api_tokens');

  const items: TabsProps['items'] = [
    {
      key: 'tags',
      label: 'Tags',
    },
    apiTokens
      ? {
          key: 'tokens',
          label: 'API tokens',
        }
      : null,
    {
      key: 'devices',
      label: 'Devices',
    },
    ...(userManagementEnabled
      ? [
          isAdmin
            ? {
                key: 'users',
                label: 'User Management',
              }
            : {
                key: 'access',
                label: 'Access',
              },
        ]
      : []),
  ].filter(Boolean) as TabsProps['items'];

  return (
    <div className="flex justify-end w-full">
      <Tabs
        tabPosition="left"
        onTabClick={handleTabClick}
        activeKey={activeKey}
        items={items}
        className="[&_.ant-tabs-content-holder]:hidden"
      />
    </div>
  );
};

export default SettingsTabs;
